<template>
  <BaseModal :width="480" title="温馨提示" v-model="show" :centered="true">
    <a-alert :show-icon="true" type="warning">
      <template #message>
        <div>* 为了更优的操作体验，建议下载使用桌面客户端</div>
      </template>
    </a-alert>
    <a-row :gutter="20">
      <a-col span="12">
        <div @click="download('win')" class="version">
          <a-icon type="windows"/>
          <p>Win 版</p>
        </div>
      </a-col>
      <a-col span="12">
        <div @click="download('mac')" class="version">
          <a-icon type="apple"/>
          <p>Mac 版</p>
        </div>
      </a-col>
    </a-row>
    <div v-if="!force" style="margin-top:30px;text-align:center;">
      <a-checkbox v-model="checked" @change="switchNotice">下次不再提醒</a-checkbox>
    </div>
  </BaseModal>
</template>

<script>
import api from "../utils/api";
import store from "../utils/store";
import BaseModal from "./BaseModal";

export default {
  name: "UseElectron",
  components: {BaseModal},
  data() {
    return {
      show: false,
      force: false,
      checked: false,
    }
  },
  methods: {
    async open(force) {
      this.force = force;
      let use = await store.get("use-electron-notice");
      this.show = !window.IS_ELECTRON && (force || !use);
    },
    download(platform) {
      window.open(api.v1.app.grapherPC(platform), "_blank");
    },
    switchNotice(e) {
      store.save("use-electron-notice", e.target.checked);
    }
  }
}
</script>

<style lang="less" scoped>
.version {
  width: 100%;
  padding: 20px 0;
  margin-top: 20px;
  text-align: center;
  cursor: pointer;
  border-radius: 4px;
  color: #777;
  font-weight: bold;
  border: 1px #e8e8e8 solid;

  .anticon {
    color: #777;
    margin: 30px 0;
    font-size: 55px;
  }
}

.version:hover {
  border-color: #ff5500;
}
</style>
